'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function BottomNav() {
  const pathname = usePathname();

  const isActive = (path: string) => pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 w-full z-50 pointer-events-none pb-[max(25px,env(safe-area-inset-bottom))]">
      <div className="w-full px-6 pointer-events-auto">
        <div className="w-full bg-slate-900/95 backdrop-blur-2xl border border-white/10 rounded-3xl pb-[20px] pt-4 shadow-[0_20px_40px_rgba(0,0,0,0.8)] relative overflow-hidden">
          <div className="absolute top-0 left-1/4 right-1/4 h-[1px] bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent"></div>

          <div className="flex items-center justify-around w-full px-2">
            <Link href="/" className="flex flex-col items-center justify-center gap-1.5 min-w-[60px] group">
              <div className="relative">
                <i className={`ph-fill ph-house text-2xl ${isActive('/') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-transform group-active:scale-90`}></i>
                {isActive('/') && (
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-emerald-400 rounded-full shadow-[0_0_8px_#10b981]"></div>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive('/') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-colors`}>Home</span>
            </Link>

            <Link href="/exchangers" className="flex flex-col items-center justify-center gap-1.5 min-w-[60px] group">
              <div className="relative">
                <span className="text-2xl group-active:scale-90 transition-all">💱</span>
                {isActive('/exchangers') && (
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-emerald-400 rounded-full shadow-[0_0_8px_#10b981]"></div>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive('/exchangers') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-colors`}>Exchangers</span>
            </Link>

            <Link href="/history" className="flex flex-col items-center justify-center gap-1.5 min-w-[60px] group">
              <div className="relative">
                <i className={`ph ph-clock-counter-clockwise text-2xl ${isActive('/history') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-all group-active:scale-90`}></i>
                {isActive('/history') && (
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-emerald-400 rounded-full shadow-[0_0_8px_#10b981]"></div>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive('/history') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-colors`}>History</span>
            </Link>

            <Link href="/profile" className="flex flex-col items-center justify-center gap-1.5 min-w-[60px] group">
              <div className="relative">
                <i className={`ph ph-gear text-2xl ${isActive('/profile') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-all group-active:scale-90`}></i>
                {isActive('/profile') && (
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-emerald-400 rounded-full shadow-[0_0_8px_#10b981]"></div>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive('/profile') ? 'text-emerald-400' : 'text-slate-400 group-hover:text-slate-200'} transition-colors`}>Settings</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}